import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Layout } from 'antd';
import {
	Cotainer,
	InfoSection,
	MainSection
} from '../../components/AppWrapper';
import SideBar from '../../components/SideBar';
import UserInfo from './UserInfo';
import ChangePw from '../ChangePw';
import APIkeys from '../APIkeys';
import { removeCookie } from '../../common/utils';
import HelpPage from '../Help';
import Wrapper, { HelpWrapper } from './style';

const { Content } = Layout;

class User extends Component {

	constructor() {
		super()
		this.state = {
			isHelp: false
		};
	}

	componentDidMount() {
		const { location } = this.props;
		if (location.pathname.indexOf('help') >= 0) {
			this.setState({ isHelp: true });
		}
		
	}

	componentDidUpdate(prevProps) {
		const { location } = this.props;
		if (prevProps.location !== location) {
			if (location.pathname.indexOf('help') >= 0) {
				this.setState({ isHelp: true });
			} else {
				this.setState({ isHelp: false });
			}
		}
	}

	renderBody = () => {
		const { location, user, userAction, history } = this.props;
		const { isHelp } = this.state;

		if (location.pathname.indexOf('password') >= 0) {
			return <ChangePw user={user} action={userAction} />;
		} else if (location.pathname.indexOf('apikey') >= 0) {
			return <APIkeys history={history} />;
		} else if (isHelp) {
			return <HelpPage />;
		}
		return <UserInfo user={user} action={userAction} />;
	};

	render() {
		return (
			<Cotainer>
				<Layout>
					<SideBar>
						<InfoSection className="less-content">
							<div>
								<h3>User Profile</h3>
								<Button block type="primary">
									<Link to="/mypage">Profile</Link>
								</Button>
								<Button block type="primary">
									<Link to="/mypage/modify-password">Security</Link>
								</Button>
								<Button block type="primary">
									<Link to="/mypage/apikey">Exchange keys</Link>
								</Button>
								<Button block type="primary">
									<Link to="/mypage/help">Help</Link>
								</Button>
								<Button block type="danger">
									<Link
										to={{ pathname: '/', state: { isLogout: true } }}
										onClick={() => {
											removeCookie('id_token');
											removeCookie('email');
										}}
									>
										Logout
								</Link>
								</Button>
							</div>
						</InfoSection>
					</SideBar>
					<Content>
						<MainSection>
							{this.state.isHelp ?
								<HelpWrapper>{this.renderBody()}</HelpWrapper> :
								<Wrapper>{this.renderBody()}</Wrapper>
							}
						</MainSection>
					</Content>
				</Layout>
			</Cotainer>
		);
	}
}

export default User;
